import { Button } from "@base/ui/Button/Button";
import { useTranslation } from "react-i18next";
import { getErrorMessage } from "react-error-boundary";

export interface ErrorFallbackProps {
  error: unknown;
  resetErrorBoundary: (...args: unknown[]) => void;
}

/**
 * Error Boundary fallback UI.
 * Use with react-error-boundary's FallbackComponent or fallbackRender.
 */
export function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  const { t } = useTranslation();
  const message = getErrorMessage(error) ?? String(error);

  return (
    <div className="flex flex-col gap-4 justify-center items-center min-h-[200px] p-6 text-center" role="alert">
      <p className="text-body2 text-gray-1000">{t("error")}</p>
      <pre className="text-left text-caption1 text-gray-500 overflow-auto max-w-full">
        {message}
      </pre>
      <Button type="button" variant="outline" color="secondary" onClick={resetErrorBoundary}>
        {t("retry")}
      </Button>
    </div>
  );
}
